import { AxiosPromise } from 'axios';
import request from '@/umi-request';

export async function queryCurrent() {
  return request({
    url: '/api/currentUser',  
    method: 'GET'
  }) as AxiosPromise;
}

export async function queryFakeList(params: any) {
  return request({
    url: '/api/fake_list',  
    method: 'GET',  
    params 
  }) as AxiosPromise;
}
